<template>
  <el-container class="h-100 w-100 bg-ff">
    <el-aside width="120px">
      <div class="title border-b-e2">{{group === 1 ? '基装报价' : group === 2 ? '主材报价' : group === 3 ? '电器报价' : '定制报价'}}</div>
      <div class="menu">
        <div v-for="(item, index) in menu" :key="index" v-if="item.permission == '' || permission.indexOf(item.permission) !== -1" :class="index === menuIndex ? 'menuActive': 'menuList'" @click="changeIndex(index,item.name)">
          <span class="cursor">{{item.name}}</span>
        </div>
      </div>
    </el-aside>
    <el-main class="flex-column flex-1">
      <div class="customerInfo flex align-center justify-space-between">
        <div class="flex align-center">
          <div>
            <div><span>客户信息：</span>{{info.name}}</div>
            <div><span>装修地址：</span>{{info.detailedAddress}}</div>
          </div>
          <div class="line"></div>
          <div>
            <div><span>设计师：</span>{{customerAssign && customerAssign.designerName ? customerAssign.designerName : '-'}}</div>
            <div><span>预算员：</span>{{customerAssign && customerAssign.beName ? customerAssign.beName : '-'}}</div>
          </div>
        </div>
        <div class="close flex align-center justify-center cursor" @click="onClose">
          <i class="el-icon-close font-18-ff"></i>
        </div>
      </div>
      <div class="content flex-column flex-1 bg-f3f4f7">
        <budget-quotation ref="budgetQuotation" :titleName="titleName" v-if="menuIndex === 0 " :budgetGroup="budgetGroup" :permission="permission" :info="info" @refresh="isRefresh" :group="group" :budget-name="budgetName" :is-activated="isActivated"></budget-quotation>
        <cost-accounting :titleName="titleName" v-else-if="menuIndex === 1" :budgetGroup="budgetGroup" :permission="permission" :info="info"></cost-accounting>
        <confirm-material :titleName="titleName" v-else-if="menuIndex === 2 " :budgetGroup="budgetGroup" :permission="permission"></confirm-material>
        <actual-amount v-else-if="menuIndex === 3 " :budgetGroup="budgetGroup"></actual-amount>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import BudgetQuotation from './budgetItem/budgetQuotation'
import CostAccounting from './budgetItem/costAccounting'
import ConfirmMaterial from './budgetItem/confirmMaterial'
import ActualAmount from './budgetItem/actualAmount'
export default {
  name: 'manager-budget',
  components: { BudgetQuotation, CostAccounting, ConfirmMaterial, ActualAmount },
  data () {
    return {
      isActivated: false,
      id: null,
      parent: null,
      budgetGroup: {},
      budgetGroupId: null,
      group: null,
      budgetName: '',
      info: {},
      customerAssign: {},
      menuIndex: 0,
      permission: [],
      menu: [{
        name: '预算报价',
        permission: ''
      }, {
        name: '成本核算',
        permission: 'checkComputation'
      }, {
        name: '材料确认',
        permission: 'materialConfirm'
      }, {
        name: '实际用量表',
        permission: ''
      }],
      titleName: '预算报价'
    }
  },
  created () {
    this.isRefresh()
  },
  mounted () {
  },
  methods: {
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'budget',
        parentGroup: 'budget'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    isRefresh () {
      this.id = this.$route.query.id
      this.parent = this.$route.query.parent
      this.budgetGroupId = this.$store.state.budgetGroupId ? this.$store.state.budgetGroupId : this.$route.query.budgetGroupId
      this.group = this.$route.query.group
      this.budgetName = this.$route.query.budgetName
      this.info = {}
      this.getInfo()
      this.getBudgetGroup()
      this.getPermission()
    },
    getBudgetGroup () {
      // if (this.$refs.budgetQuotation.budgetGroupId) {
      //   this.budgetGroupId = this.$refs.budgetQuotation.budgetGroupId
      // }
      this.axios.post('budget/getById', this.qs.stringify({ id: this.budgetGroupId })).then(res => {
        if (res.data.success) {
          this.budgetGroup = res.data.data
        }
      })
    },
    getInfo () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customer/getById`, this.qs.stringify({
        id: this.id
      })).then(res => {
        if (res.data.success) {
          this.info = res.data.data
          this.customerAssign = res.data.data.customerAssign
        }
      })
    },
    onClose () {
      this.$router.go(-1)
    },
    changeIndex (a, b) {
      this.menuIndex = a
      this.titleName = b
      this.getBudgetGroup()
      // this.$refs.budgetQuotation.refresh()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-aside {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  position: relative;
}
.el-main {
  padding: 0;
}
.aside-top {
  height: 5px;
  background: #46b8b0;
  width: 100%;
}
.el-aside .title {
  background: #ffffff;
  height: 50px;
  line-height: 50px;
  text-align: left;
  font-weight: bold;
  font-size: 18px;
  color: #30313a;
  padding-left: 20px;
}
.customerInfo {
  width: 100%;
  height: 50px;
  /*background: #fff;*/
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  font-size: 12px;
  color: #30313a;
  text-align: left;
  padding-left: 20px;
  position: relative;
}
.close {
  width: 50px;
  height: 50px;
  background: #ff5555;
}
.customerInfo span {
  color: #b9b9b9;
}
.line {
  height: 32px;
  background: #f3f4f7;
  width: 1px;
  margin: 0 20px;
}
.menuList {
  color: #30313a;
  font-size: 14px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: dashed 1px #e2e2e2;
}
.menuActive {
  color: #ffffff;
  font-size: 14px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #46b8b0;
  border-bottom: dashed 1px #46b8b0;
}
.hr {
  width: 100%;
  height: 1px;
  background: #e2e2e2;
  margin: 10px 0;
}
.hr-dashed {
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed #e2e2e2;
  margin: 12px 0;
}
.content {
  padding: 10px 20px;
}
.decoration-line {
  width: 4px;
  height: 16px;
  background-color: #46b8b0;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/managerBudget.vue